import { render, staticRenderFns } from "./listagemEmpresas.vue?vue&type=template&id=1b941ccc&scoped=true"
import script from "./listagemEmpresas.vue?vue&type=script&lang=js"
export * from "./listagemEmpresas.vue?vue&type=script&lang=js"
import style0 from "./listagemEmpresas.vue?vue&type=style&index=0&id=1b941ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b941ccc",
  null
  
)

export default component.exports